export const TABS = {
    LOGS: 'Logs',
    SETTINGS: 'Settings',
};
